<div class="custom-date-time-range-picker">
    <div class="time-range">
        <div class="first-time-range">
            <button type="button" class="picker-icon-button time-range-icons" (click)="setTodayDateTime('startYear')"
                [attr.data-automation-id]="automationId + '-calendar-today-date-on-after-icon-button'"
                title="Click to enter today's date">
                <i class="fa fa-calendar calendar-icon"></i>
            </button>
            <input class="after-before-date" type="text" id="startYear" [(ngModel)]="startYear"
                placeholder="{{placeholderField1}}" (focus)="onPickerInputFocus(true, $event)"
                (focusout)="onPickerInputFocus(false, $event)"
                [attr.data-automation-id]="automationId + '-calendar-today-date-on-after-input'"
                [(resScrollablePopover)]="isLeftDateInvalid" [isSingleLine]="true" [popoverErrorMessage]="pickerError"
                [popoverType]="'error'" popoverPlacement="bottom"
                [popoverAutomationId]="automationId + '-calendar-today-date-on-after-input-error-message'" />
            <button type="button" [hidden]="!startYear" class="picker-icon-button clear-icon after-date"
                (click)="onClearClick('startYear')" [attr.data-automation-id]="automationId + '-on-after-clear-button'">
                <i class="fa fa-times"></i>
            </button>
        </div>
        <div>
            <button type="button" class="picker-icon-button time-range-icons" (click)="setTodayDateTime('startHour')"
                [attr.data-automation-id]="automationId + '-calendar-today-current-time-on-after-icon-button'"
                title="Click to enter the current time">
                <i class="fa fa-clock-o clock-icon"></i>
            </button>
            <input class="after-before-time" type="text" id="startHour" [(ngModel)]="startHour"
                placeholder="{{placeholderField2}}" (focus)="onPickerInputFocus(true, $event)"
                (focusout)="onPickerInputFocus(false, $event)"
                [attr.data-automation-id]="automationId + '-calendar-today-time-on-after-input'"
                [(resScrollablePopover)]="isRightDateInvalid" [isSingleLine]="true" [popoverErrorMessage]="pickerError"
                [popoverType]="'error'" popoverPlacement="bottom"
                [popoverAutomationId]="automationId + '-calendar-today-date-on-after-input-error-message'" />
            <button type="button" [hidden]="!startHour" class="picker-icon-button clear-icon after-time"
                (click)="onClearClick('startHour')"
                [attr.data-automation-id]="automationId + '-on-after-time-clear-button'">
                <i class="fa fa-times"></i>
            </button>
        </div>
        <div class="separator">~~</div>
        <div>
            <button type="button" class="picker-icon-button time-range-icons" (click)="setTodayDateTime('endYear')"
                [attr.data-automation-id]="automationId + '-calendar-today-date-on-before-icon-button'"
                title="Click to enter today's date">
                <i class="fa fa-calendar calendar-icon"></i>
            </button>
            <input class="after-before-date" type="text" id="endYear" [(ngModel)]="endYear"
                placeholder="{{placeholderField3}}" (focus)="onPickerInputFocus(true, $event)"
                (focusout)="onPickerInputFocus(false, $event)"
                [attr.data-automation-id]="automationId + '-calendar-today-date-on-before-input'" />
            <button type="button" [hidden]="!endYear" class="picker-icon-button clear-icon before-date"
                (click)="onClearClick('endYear')" [attr.data-automation-id]="automationId + '-on-before-clear-button'">
                <i class="fa fa-times"></i>
            </button>
        </div>
        <div>
            <button type="button" class="picker-icon-button time-range-icons" (click)="setTodayDateTime('endHour')"
                [attr.data-automation-id]="automationId + '-calendar-today-current-time-on-before-icon-button'"
                title="Click to enter the current time">
                <i class="fa fa-clock-o clock-icon"></i>
            </button>
            <input class="after-before-time end-time" type="text" id="endHour" [(ngModel)]="endHour"
                placeholder="{{placeholderField2}}" (focus)="onPickerInputFocus(true, $event)"
                (focusout)="onPickerInputFocus(false, $event)"
                [attr.data-automation-id]="automationId + '-calendar-today-date-on-before-input'" />
            <button type="button" [hidden]="!endHour" class="picker-icon-button clear-icon before-time"
                (click)="onClearClick('endHour')"
                [attr.data-automation-id]="automationId + '-on-before-time-clear-button'">
                <i class="fa fa-times"></i>
            </button>
        </div>

    </div>
    <div class="picker-ranges">
        <div class="range1">
            <bs-datepicker-inline [bsValue]="leftDatePicker" [bsConfig]="pickerConfig"
                (bsValueChange)="onDatePickerLeftChange($event)"
                [attr.data-automation-id]="automationId + '-calendar-left-picker-input'" name="leftdatepickerinput"
                ngDefaultControl>
            </bs-datepicker-inline>
        </div>
        <div class="date-arrow-setters">
            <button type="button" class="picker-icon-button arrow-btn" (click)="setCalendarDate('left')"
                [attr.data-automation-id]="automationId + '-set-left-calendar-date-picker-button'"
                title="Duplicate the selected date/time">
                <i class="fa fa-arrow-left block-align"></i>
            </button>
            <div class="divider"></div>
            <button type="button" class="picker-icon-button arrow-btn" (click)="setCalendarDate('right')"
                [attr.data-automation-id]="automationId + '-set-right-calendar-date-picker-button'"
                title="Duplicate the selected date/time">
                <i class="fa fa-arrow-right block-align"></i>
            </button>
        </div>
        <div class="range2">
            <bs-datepicker-inline [bsValue]="rightDatePicker" [bsConfig]="pickerConfig"
                (bsValueChange)="onDatePickerRightChange($event)"
                [attr.data-automation-id]="automationId + '-calendar-right-picker-input'" name="rightdatepickerinput"
                ngDefaultControl>
            </bs-datepicker-inline>
        </div>

    </div>
    <div class="actions">
        <div class="left">
            <span class="text-select">Select:</span>
            <button type="button" class="secondary-button today-btn" (click)="onSelectDateClick('0')"
                [attr.data-automation-id]="automationId + '-set-today-date-picker-button'">
                Today
            </button>
            <button type="button" class="secondary-button yesterday-btn" (click)="onSelectDateClick('-1')"
                [attr.data-automation-id]="automationId + '-set-yesterday-date-picker-button'">
                Yesterday
            </button>
            <div class="btn-group" dropdown>
                <button id="button-basic" dropdownToggle type="button" class="secondary-button elypsis-btn"
                    [attr.data-automation-id]="automationId + '-ellipsis-button'" aria-controls="dropdown-basic">
                    <img src="assets/images/ellipsis_black.png">
                </button>
                <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu elypsis-dropdown" role="menu"
                    aria-labelledby="button-basic">
                    <li role="menuitem"><a class="dropdown-item" (click)="onSelectDateClick('24')"
                            [attr.data-automation-id]="automationId + '-set-last-24-hours-date-picker-button'">Last 24
                            hours</a></li>
                    <li role="menuitem"><a class="dropdown-item" (click)="onSelectDateClick('7')"
                            [attr.data-automation-id]="automationId + '-set-last-7-days-date-picker-button'">Last 7
                            days</a>
                    <li role="menuitem"><a class="dropdown-item" (click)="onSelectDateClick('30')"
                            [attr.data-automation-id]="automationId + '-set-last-30-days-date-picker-button'">Last 30
                            days</a>
                    </li>
                </ul>
            </div>
        </div>

        <div class="right">
            <button type="button" class="primary-button btn-margin" (click)="onApplyClick()"
                data-automation-id="date-time-picker-primary-button"
                [disabled]='!startYear && !endYear && !startHour && !endHour && (!isLeftDateInvalid || !isRightDateInvalid)'>
                <i class="fa fa-check"></i>Apply
            </button>

            <button type="button" class="secondary-button" data-automation-id="date-time-picker-secondary-button"
                (click)="onCancelClick()">
                Cancel
            </button>
        </div>

    </div>
</div>